import { useGetMetadataCurrencyToken } from "../../api/currency";

export interface Root {
  id: string;
  symbol: string;
}

export const useMetadataCurrencyToken = (networkId?: number) => {
  const {
    data = {
      data: { data: [] },
    },
    isLoading,
    refetch,
  } = useGetMetadataCurrencyToken(networkId);

  const metadataCurrencyToken = data.data.data.map((item: Root) => {
    return {
      value: item.id,
      label: item.symbol,
    };
  });
  return {
    metadataCurrencyToken,
    dataCurrencyToken: data.data.data,
    isLoading,
    refetch,
  };
};
